import React from "react";
import { Box, Tab, Tabs } from "@mui/material";

import { useTranslation } from "react-i18next";
import { getTabItems } from "../types/tabItemsTypes";

interface WebTabsProps {
    onTabChange: (index: number) => void;
    currentTab: number;
}

const WebTabs: React.FC<WebTabsProps> = ({ onTabChange, currentTab }) => {
    const handleChange = (_: React.SyntheticEvent, newValue: number) => {
        onTabChange(newValue);
    };
    const { t } = useTranslation();

    const tabItems = getTabItems(t);

    return (
        <Box
            sx={{
                display: "flex",
                height: "100%",
                marginTop: "38px",
            }}
        >
            <Tabs
                orientation="vertical"
                value={currentTab}
                onChange={handleChange}
                TabIndicatorProps={{
                    style: {
                        backgroundColor: "#e53835",
                    },
                }}
                sx={{
                    borderRight: 1,
                    borderColor: "divider",
                    minWidth: 160,
                    paddingTop: 2,
                    backgroundColor: "#F0F4F8",
                    "& .MuiTab-root": {
                        alignItems: "start",
                        textTransform: "capitalize",
                        color: "#333",
                    },
                    "& .Mui-selected": {
                        color: "#e53835 !important",
                        fontWeight: 600,
                    },
                }}
            >
                {tabItems.map((label, index) => (
                    <Tab
                        key={index}
                        label={label}
                        sx={{ margin: "0.5rem 0 0.5rem 0" }}
                    />
                ))}
            </Tabs>
        </Box>
    );
};

export default WebTabs;
